import type { PublicSlotKey } from '@/apilib';
import type { WorkspaceRightPanelApi } from './workspaceRightPanelApi';

export const WorkspaceRightPanelApiKey: PublicSlotKey<WorkspaceRightPanelApi> =
  {
    name: 'WorkspaceRightPanelApi',
    public: true,
  };
